import { BasicQueryStringUtils } from '@openid/appauth';

class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input) {
    return super.parse(input, false /* never use hash */);
  }
}
export default NoHashQueryStringUtils;
